<template>
	<div v-if="current.status != 'win' && current.status != 'lose'" class="box box-map">

		<div v-if="visible" class="map">
			<div v-for="row in current.board" class="map-row" :style="map_row_style" :class="{ past: row.id < current.row, active: row.id == current.row, incoming: row.id < current.row+3 && row.id > current.row }">
				<div class="line"></div>
				<div class="player"></div>
				<div class="icons">
					<div v-if="has_one('item', row)" class="icon item"><span class="tooltip">{{ l.item }}</span></div>
					<div v-if="has_full('monster', row)" class="icon monsters"><span class="tooltip">{{ l.fight }}</span></div>
					<div v-if="has_one('boss', row)" class="icon boss"><span class="tooltip">{{ l.boss }}</span></div>
					<div v-if="has_one('biome', row)" class="icon biome"><span class="tooltip">{{ l.next_level }}</span></div>
					<div v-if="has_one('place', row)" class="icon place"><span class="tooltip">{{ l.chest }}</span></div>
				</div>
			</div>
		</div>			

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'mapping',
	computed: Object.assign(mapGetters([ 'l', 'lang', 'current', 'game' ]), {
		visible: function() {
			return this.current.location == 'main' && _.findIndex(this.game.player.hero.bag, { slug: 'map' }) > -1
		},
		map_row_style: function() {
			if (this.$el)
				return {
					// height: (1 * this.$el.offsetHeight / this.current.board.length) + 'px'
				}
			return {}
		}
	}),
	methods: {
		has_one: function(type, row) {
			var temp = false

			for (var i in row.slots) {
				var card = row.slots[i].card
				if (card) {
					if (type == 'boss' && card.type == 'monster' && card.boss) return true
					if (card.type == type) return true
				}
			}

			return temp
		},
		has_full: function(type, row) {
			var temp = 0
			var n = 0
			for (var i in row.slots) {
				var card = row.slots[i].card
				if (card) {
					n++
					if (card.type == type && !card.boss) temp++
				}
			}
			return n && temp == n
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.box-map
	height 100%
	.map
		position absolute
		left 0
		bottom 0
		right 0
		display flex
		flex-direction column-reverse
		// height calc(100% - 96px)
		height 100%
		.map-row
			flex 1
			&.past
				opacity 0.25
			&.incoming
				opacity 1
				.line
					background-color light
			&.active
				opacity 1
				.line
					background-color light
				.player
					display block
			.line
				position absolute
				left 8px
				top 0
				bottom 0
				width 4px
				background-color lighten(dark, 25%)
				border-top 1px solid dark
				border-bottom 1px solid dark
			.icons
				position absolute
				left 20px
				top 50%
				height 16px
				margin-top -8px
				width calc(100% - 24px)
				display flex
				align-items center
				justify-content flex-start
				.icon
					display inline-block
					width 16px
					height 16px
					margin 0 8px 0 0
					background url(../../assets/img/ui/icons.png) top left no-repeat
					background-size auto 32px
					&.item
						background-position 0 0
					&.monsters
						background-position -16px 0
					&.boss
						background-position -32px 0
					&.biome
						background-position -32px -16px
					&.place
						background-position -48px -16px
					&:hover
						.tooltip
							display block
					.tooltip
						display none
						position absolute
						left 24px
						top 0
						z-index 4
						margin-top -8px
						white-space nowrap
						font-size 1.6rem
						line-height 16px
						background-color darken(dark, 10%)
						padding 8px
			.player
				display none
				position absolute
				left 0
				bottom 0
				height 16px
				width 16px
				margin-bottom -6px
				// border-radius 100%
				// background-color light
				width 0
				height 0
				border-style solid
				border-width 6px 0 6px 6px
				border-color transparent transparent transparent light


</style>
